import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { AngularFireDatabase } from '@angular/fire/compat/database';
import { Observable } from 'rxjs';

@Injectable()
export class ConfigService {
	constructor(private db: AngularFireDatabase, private afAuth: AngularFireAuth) {}

	hydrate(): Observable<any> {
		return this.db.object('/config').valueChanges();
	}
	getCurrentDate() {
		return this.db.object('/upload/CardholderReport').valueChanges();
	}
	setCurrentDate(date) {
		return this.db.object('/upload/CardholderReport').set(date);
	}
}
